// Какой блок «Кто победит?» рисовать (HQ-1699). Ответ на голос живёт локально, пока экран присылает тот же блок,
// от которого голосовали; живой опрос экрана прислал новый who_wins (закрыт, другие доли, голос с другого устройства) —
// рисуем его, локальный ответ устарел.
import type { WhoWinsBlock } from '../api/matchTypes';

/** Локальный ответ на голос и блок экрана, от которого он получен. */
export interface LocalVote { base: WhoWinsBlock; block: WhoWinsBlock }

/** Тот же ли блок прислал экран: ссылка или содержимое (повторный опрос без перемен даёт равный объект). */
export function samePollBlock(a: WhoWinsBlock, b: WhoWinsBlock): boolean {
  return a === b || JSON.stringify(a) === JSON.stringify(b);
}

/** Блок к показу: локальный ответ, пока его база совпадает с текущим блоком экрана; иначе — блок экрана. */
export function shownPollBlock(initial: WhoWinsBlock, local: LocalVote | null): WhoWinsBlock {
  return local && samePollBlock(local.base, initial) ? local.block : initial;
}
